export const CLICK_CATALGOUE = ['open_ecatalogue', 'Main menu sidebar'];

export const CLICK_CATALOGUE_DETAIL = ['open_ecatalogue', 'Main menu content'];

export const CLICK_BURGER_MENU = ['open_main_menu', 'Top navigation'];

export const CLICK_CATEGORY_BRAND = ['select_brand', 'Main menu content'];

export const START_SEARCH = ['search_start', 'Search 1'];

export const CLICK_FAVORITE_ICON = ['open_favorites', 'Top navigation'];

export const CLICK_NOTIFICATION_ICON = ['notifications', 'open_notification_overview'];
